import {API_ENDPOINTS} from '../constants';
import {getAuthToken} from './account';

export interface IAttachment {
    accountName: string;
    created: number;
    fileName: string;
    url: string;
    userName: string;
    name: string;
}

export const get = async (
    name?: string,
    organization?: string
): Promise<{success: boolean; data?: IAttachment[] | IAttachment}> => {
    try {
        const request = await fetch(`${API_ENDPOINTS.attachments(name, organization)}`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${getAuthToken()}`,
            },
            method: 'GET',
        });
        if (request.ok) return {success: true, data: await request.json()};
        else return {success: false};
    } catch (ex) {
        return {success: false};
    }
};

export const post = async (
    file: File
): Promise<{success: boolean; data?: IAttachment; message?: string}> => {
    const body = new FormData();
    body.append('file', file);
    try {
        const request = await fetch(API_ENDPOINTS.attachments(), {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${getAuthToken()}`,
            },
            body,
        });
        if (request.ok) return {success: true, data: await request.json()};
        else return {success: false};
    } catch (ex) {
        return {
            success: false,
            message:
                'Failed to upload one or more of your files. Please make sure file size does not exceet 10mb and is of type JPEG, PNG, PDF, DOC',
        };
    }
};



// WEBPACK FOOTER //
// ./src/services/attachment.ts